import type { TrackingMethod } from '../dataProvider';

/**
 * Admin-side helpers for the offline stores surface (D-offline-stores). The offline tracking
 * rails REUSE the existing TrackingMethod enum (NO new value): an offline venue tracks by
 * 'clo' (card-linked offer) or 'ob' (Open Banking). The 'ob' value is OPEN BANKING here (the
 * platform's consistent meaning); the backbone enum's "order-based" gloss is corrected at
 * migration (the real TrackingMethod is the swap seam, see schema-reconciliation).
 */

/** The two offline tracking rails (a subset of the shared TrackingMethod enum). */
export const OFFLINE_TRACKING_METHODS: readonly TrackingMethod[] = [
  'clo',
  'ob',
];

/** Offline-tracking labels. 'ob' is OPEN BANKING (not the backbone's "order-based" gloss). */
export const OFFLINE_TRACKING_LABEL: Partial<Record<TrackingMethod, string>> = {
  clo: 'Card-linked offer (CLO)',
  ob: 'Open Banking (OB)',
};

/** The display label for an offline venue's tracking method. */
export const trackingMethodLabel = (m: TrackingMethod): string =>
  OFFLINE_TRACKING_LABEL[m] ?? m;
